<!-- 北京互联网法院存证查询 -->
<template>
  <div class="region" @keydown.enter="search">
    <div class="certificate">
      <div class="certificate-item">
        <p class="item-title">{{info.title_1}}</p>
        <div class="item-input">
          <input
            type="text"
            v-model.trim="formInfo.number"
            @blur="verificationNumber"
            :placeholder="info.holder_1"
          />
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.number.isError">{{tipsInfo.number.msg}}</div>
        </div>
      </div>
      <div class="certificate-item">
        <p class="item-title">{{info.title_vCode}}</p>
        <div class="item-vcode">
          <input
            type="text"
            v-model.trim="formInfo.vcode"
            @blur="verificationVcode"
            :placeholder="info.holder_vCode"
          />
          <img :src="vcodeUrl?vcodeUrl:''" alt @click="getVcode" />
          <span @click="getVcode">{{info.change_vCode}}</span>
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.vcode.isError">{{tipsInfo.vcode.msg}}</div>
        </div>
      </div>
      <div class="certificate-operate" >
        <button :class="['search',success?'pendding':'']" @click="search" :disabled="success">{{info.search}}</button>
        <button class="download" @click="downLoad" >
          <a :href="funDownloadUrl">
            <i></i>
            {{info.download}}
          </a>
        </button>
      </div>
    </div>
    <div class="listbox">
        <table class="table" style="border-bottom: 0px;">
      <thead>
        <tr>
          <td style="width:3.7%">{{info.tableHeader_1}}</td>
          <td style="width:40.2%; text-align: left; padding-left: 10px;">{{info.tableHeader_2}}</td>
          <td style="width:46%; text-align: left; padding-left: 10px;">{{info.tableHeader_3}}</td>
        </tr>
      </thead>
    </table>
    <div class="searchlist" v-if="serachList.length" :style="{'width': '1091px','height':'239px','overflow-y':serachList.length>=8?'scroll':'visible','margin-left':'0px'}">
        <table class="table">
            <tbody v-if="serachList.length">
            <tr v-for="(item,index) in serachList" :key="index">
              <td style="width:4.17%">{{index+1}}</td>
              <td style=" text-align: left; padding-left: 10px;position: relative;">
                <input
                  id="input"
                  ref="text"
                  :value="copymag"
                  style="opacity:0;  position: absolute;left:0;"
                />
                <span class="ID-txt">{{item.txid?item.txid:"未查询到相关数据"}}</span>
                <i class="copyTxid" v-if="item.txid!=='未查询到相关数据' && item.txid!==''" :data-clipboard-text="item.txid" @click="EvidenceCopyTxid(index)"></i>
              <span class="copybox none" >复制成功</span>
              </td>
              <td style="width:549.5px; text-align: left; padding-left: 10px; position: relative;">
                <input
                  id="input"
                  ref="text1"
                  :value="copymag1"
                  style="opacity:0;  position: absolute;left:0"
                />
                <span class="ID-txt">{{item.extrinsic_hash?item.extrinsic_hash:"未查询到相关数据"}}</span>
                <i class="copyHash" v-if="item.extrinsic_hash!=='未查询到相关数据' && item.extrinsic_hash!==''"  :data-clipboard-text="item.extrinsic_hash" @click="EvidenceCopyHash(index)"></i>
                 <span class="copybox1 none">复制成功</span> 
              </td>
            </tr>
            
          </tbody>
            <tbody v-show="!serachList.length">
              
              <tr >
                <td style="width:3.7%"></td>
                <td style=" text-align: left; padding-left: 10px;position: relative;"> 
                  <span class="ID-txt" v-if="!noList"></span>
                    <span class="ID-txt" v-else>{{info.errCode}}</span>
                </td>
                <td style="width:510px; text-align: left; padding-left: 10px; position: relative;">
                  <span class="ID-txt" v-if="!noList"></span>
                    <span class="ID-txt" v-else>{{info.errCode}}</span>
                </td>
              </tr>
            </tbody>
        </table>
    </div>
     <div class="searchlist" v-if="!serachList.length" :style="{'width': '1091px','height':'239px','overflow-y':serachList.length>=8?'scroll':'visible','margin-left':'0px'}">
        <table class="table">
            <tbody v-show="!serachList.length">
              <tr >
                <td style="width: 4.13%;"></td>
                <td style=" text-align: left; padding-left: 10px;position: relative;"> 
                  <span class="ID-txt" v-if="!noList"></span>
                    <span class="ID-txt" v-else>{{info.errCode}}</span>
                </td>
                <td style="width:549.5px; text-align: left; padding-left: 10px; position: relative;">
                  <span class="ID-txt" v-if="!noList"></span>
                    <span class="ID-txt" v-else>{{info.errCode}}</span>
                </td>
              </tr>
            </tbody>
        </table>
    </div>
    </div>
  
  </div>
</template>
<script>
import { vaildateIDCard, ivaildateBLCard } from "@/utils/validate";
import Clipboard from 'clipboard'; 
import $ from "jquery"
export default {
  data() {
    return {
       idCopy:false,
      successCopy:false,
      copymag: "",
      copymag1: "",
      noList:false,
      isDownload:true,
      success:false,
      formInfo: {
        number: "",
        code: "",
        vcode: ""
      },
      submitInfo: {
        number: "",
        code: "",
        vcode: ""
      },
      tipsInfo: {
        number: {
          isError: false,
          msg: this.info.err
        },
        vcode: {
          isError: false,
          msg: this.info.err
        }
      },
      vcodeUrl: "",
      serachList: [],
      funDownloadUrl: "javascript:;"
    };
  },
  props: ["info"],
  computed: {},
  methods: {
    // 验证证书编号
    verificationNumber() {
      let number=/^(([A-Z]+\-[A-Z]+\-)|([A-Z]+\-))(\d{16}|\d{18}|\d{20})$/;
      let code=/^[A-Z]{2}[a-f0-9]{8}\d{13}$/;
      this.submitInfo.number=""
      if (this.formInfo.number.trim()) {
         this.formInfo.number=this.formInfo.number.trim();
        if (number.test(this.formInfo.number)) {
          this.submitInfo.number=this.formInfo.number;
          this.tipsInfo.number.isError = false;
          return true;
        } else if(code.test(this.formInfo.number)||this.formInfo.number.length==20){
          this.submitInfo.code=this.formInfo.number;
           this.tipsInfo.number.isError = false;
          return true;
        }else{
          this.tipsInfo.number.isError = true;
          this.tipsInfo.number.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.number.isError = true;
        this.tipsInfo.number.msg = this.info.void_1;
        return false;
      }
    },
    // 验证验证码
    verificationVcode() {
      this.submitInfo.vcode=""
      if (this.formInfo.vcode) {
        if (/^([a-z]|[A-Z]|[0-9]){4}$/.test(this.formInfo.vcode)) {
            this.submitInfo.vcode=this.formInfo.vcode;
          this.tipsInfo.vcode.isError = false;
          return true;
        } else {
          this.tipsInfo.vcode.isError = true;
          this.tipsInfo.vcode.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.vcode.isError = true;
        this.tipsInfo.vcode.msg = this.info.void_vCode;
        return false;
      }
    },
    //查询
    search() {
      this.isSearch = true;
      if (this.verificationNumber() && this.verificationVcode()) {
        this.success=true;
        // console.log("开始查询");
        this.$ajax
          .get("/webapi/validateQuery/certificateQueryTxId", {
            params: {
              certificateNum: this.submitInfo.number, //证书编码
              vcode: this.submitInfo.vcode, //验证码
              extractingCode: this.submitInfo.code //提取码
            }
          })
          .then(res => {
            this.success=false;
            if (res.data.code == 200) {
              this.noList=false;
              // console.log(res.data.extraData, "北京查询");
              this.serachList = res.data.extraData.externalHashList;
               this.formInfo.vcode=""
               this.getVcode();
              //是否下载
              if(this.serachList.length){
                 this.isDownload=false;                 
              }else{
                this.isDownload=true;
              }
            } else if (res.data.code === 106) {
              this.noList=true
              this.isDownload=true;
              this.isSearch = true;
              this.serachList=[]
               this.formInfo.vcode=""
              this.getVcode();
            } else if (res.data.code === 1005) {
              this.noList=false
              this.isDownload=true;
              this.tipsInfo.vcode.isError = true;
              this.tipsInfo.vcode.msg = this.info.err_3;
               this.formInfo.vcode=""
              this.getVcode();
              this.serachList=[]
            } else {
              this.isDownload=true;
              this.isSearch = false;
              // this.$emit("noReal", true);
              this.getVcode();
            }
          });
      } else {
         this.success=false;
        this.isDownload=true;
        this.verificationNumber();
        this.verificationVcode();
      }
    },
    clearAll(){
     this.submitInfo.code=""
      this.formInfo.number = "";
      this.formInfo.code = "";
    },
    downLoad(){
        this.$ajax
          .get("/webapi/validateQuery/downloadBcFile", {
            params: {
              certificateNum: this.submitInfo.number, //证书编码
              extractingCode: this.submitInfo.code //提取码
            }
          }).then(res=>{
            if(res.data){
              var date=new Date(),
              Y = date.getFullYear() + '-',
              M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-',
              D = date.getDate() + ' ';
              var elink = document.createElement('a'); 
              elink.download ='存证ID_'+Y+M+D+".bc"; 
              elink.style.display = 'none'; 
              var blob = new Blob([res.data], {type: 'application/force-download'});
              elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
              elink.click();
              document.body.removeChild(elink);
            }
            // console.log(res,"下载bx文件")
          })
    },
    //继续查询
    continueSearch() {
      this.formInfo.number = "";
      this.formInfo.code = "";
      this.formInfo.vcode = "";
      this.tipsInfo.number.isError = false;
      this.tipsInfo.code.isError = false;
      this.tipsInfo.vcode.isError = false;
      this.isSearch = true;
      this.getVcode();
    },
    //更换验证码
    getVcode() {
      this.$ajax.get("/webapi/common/getCode").then(res => {
        if (res.data.code == 200) {
          this.vcodeUrl = "data:image/png;base64," + res.data.extraData.code;
        }
      });
    },
    //复制id
    EvidenceCopyTxid(ind) {
       var clipboard = new Clipboard(".copyTxid");
        clipboard.on("success", e => {
     $('.copybox').eq(ind).removeClass('none').addClass("block");
        setTimeout(() => {
                 $('.copybox').eq(ind).removeClass('block').addClass("none");
        }, 1000);
  //         this.$message({type:"success",message:"复制成功",}); //这里你如果引入了elementui的提示就可以用，没有就注释即可
          // 释放内存
          clipboard.destroy();
        });
    },
    EvidenceCopyHash(ind){
        var clipboard = new Clipboard(".copyHash");
        clipboard.on("success", e => {
      $('.copybox1').eq(ind).removeClass('none').addClass("block");
        setTimeout(() => {
                 $('.copybox1').eq(ind).removeClass('block').addClass("none");
        }, 1000);
  //         this.$message({type:"success",message:"复制成功"}) //这里你如果引入了elementui的提示就可以用，没有就注释即可
          // 释放内存
          clipboard.destroy();
        });
    }
  },
  mounted() {
    this.getVcode();
  }
  ,watch:{
			'$route' () {
				let pos = this.$router.history.current.path.indexOf("cn");
				if (pos) {
           if (this.formInfo.vcode.trim()) {
             this.tipsInfo.vcode.msg = this.info.err;
           }else{
             this.tipsInfo.vcode.msg = this.info.void_vCode;
           }
           if (this.formInfo.number.trim()) {
              this.tipsInfo.number.msg = this.info.err;
           }else{
               this.tipsInfo.number.msg = this.info.void_1;
           }
				}
			}
		}
};
</script>
<style lang="scss" scoped>
.region {
  width: 100%;
  .certificate {
    display: flex;
    justify-content: space-between;
    width: 1074px;
    padding-top: 40px;
    margin: 0 auto;
    &-item {
      margin-bottom: 6px;
      margin-top: -10px;
      .item {
        &-title {
          height: 16px;
          line-height: 16px;
          font-size: 14px;
          color: #fff;
        }
        &-input {
          input {
            outline: none;
            width: 340px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
          }
        }
        &-tips {
          height: 28px;
          div {
            height: 28px;
            line-height: 28px;
            padding-left: 14px;
            font-size: 12px;
            color: #d0444f;
          }
        }
        &-vcode {
          input {
            outline: none;
            width: 198px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
          }
          img {
            width: 90px;
            height: 40px;
            margin-left: 15px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-left: 15px;
            color: #bfbfc2;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
    &-operate {
      display: flex;
      justify-content: space-between;
      width: 310px;
      height: 95px;
      padding-top: 16px;
      button.search {
        height: 40px;
        line-height: 40px;
        background-color: #c62e3f;
        color: #fff;
        font-size: 14px;
        &:hover {
          background-color: #ea4b5d;
        }
      }
      .search {
        width: 120px;
      }
      .pendding{
        background: #d2d2d2 !important;
        color: #fff;
      }
      .pendding:hover{
        background: #d2d2d2 !important;
        color: #fff;
      }
      .download {
         height: 40px;
        line-height: 40px;
        color: #fff;
          width: 170px;
        border:1px solid #ae160c;
       background: no-repeat;
        font-size: 14px;
        a {
          color: #ae160c;
        }
        &:hover {
          color: #fff;
          background-color: #c62e3f;
          border:1px solid #c62e3f;
        }
        &:hover a{
          color: #fff;
        }
        &:hover i {
          display: inline-block;
          width: 15px;
          height: 14px;
          margin-right: 6px;
          vertical-align: middle;
          background: url("~img/validateQuery/evidence_icon_hor.png") center
            no-repeat;
        }
        i {
          display: inline-block;
          width: 15px;
          height: 14px;
          margin-right: 6px;
          vertical-align: middle;
          background: url("~img/validateQuery/evidence_icon_nor.png") center
            no-repeat;
        }
      }
    }
  }
  .table {
    width: 1074px;
    // margin: 0 auto;
    color: #fff;
    border-right: 1px solid #d2d2d2;
    border-bottom: 1px solid #d2d2d2;
    border-collapse: collapse;
    border-spacing: 0;
    tr {
      td {
        position: relative;
        height: 34px;
        text-align: center;
        vertical-align: middle;
        word-break: break-all;
        font-size: 12px;
        border-top: 1px solid #d2d2d2;
        border-left: 1px solid #d2d2d2;
        cursor: pointer;
        i {
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          width: 14px;
          height: 16px;
          vertical-align: middle;
          background: url("~img/validateQuery/rescue_nor_icon.png") center
            no-repeat;
        }
         i:hover{
             background: url('~img/validateQuery/rescue_hov_pre_icon.png') center no-repeat;
        }
         .copybox{
          width: 60px;
          height:20px;
          background: #fff;
          text-align: center;
          line-height: 20px;
          color:#002662;
          font-size: 12px;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          right: 27px;
          top: 5px;
          z-index: 9;
        }
          .copybox1{
          width: 60px;
          height:20px;
          background: #fff;
          text-align: center;
          line-height: 20px;
          color:#002662;
          font-size: 12px;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          right: 27px;
          top: 5px;
          z-index: 9;
        }
         .none{
          display: none;
        }
        .block{
          display: block;
        }
      }
      & + tr {
        td + td {
          &:hover {
            color: #ea4b5d;
            i {
              background: url("~img/validateQuery/rescue_hov_pre_icon.png")
                center no-repeat;
            }
          }
        }
      }
    }
  }
    tbody  td:hover{
        color: #ea4b5d;
      }
  .ID-txt {
    text-overflow: ellipsis;
    display: inline-block;
    width: 421px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-right: 20px;
    white-space: nowrap;
    overflow: hidden;
  }
}
.listbox{
  width: 1092px;
    margin: 0 auto;
    padding-left: 9px;
}
</style>
